import { Observable } from 'rxjs';

export abstract class ExternalSystemsService {
    abstract getConfiguredConnectors(orgTag: string): Observable<any>;
    abstract getExternalSystemLookup(connectorTag: string, userId: string, orgTag: string): Observable<any>;
}
